import { Users, Rocket } from 'lucide-react';

export const LAYOUT_CONFIG = {
    container: {
        layout: 'flex h-screen overflow-hidden',
        background: 'bg-black',
        textColor: 'text-gray-100'
    },
    sidebar: {
        width: {
            open: 'w-full md:w-48',
            closed: 'w-0 overflow-hidden'
        },
        position: 'md:fixed md:left-0 md:top-0 md:h-screen md:overflow-y-auto',
        background: 'bg-gray-900',
        border: 'border-r border-gray-800',
        transition: 'transition-all duration-300 ease-in-out z-30'
    },
    mainContent: {
        transition: 'transition-all duration-300 ease-in-out',
        marginLeft: {
            open: 'md:ml-48',
            closed: 'ml-0'
        }
    }
};

export const NAV_MENU_CONFIG = {
    items: [
        {
            id: 'deployments',
            label: 'Deployments',
            icon: Rocket,
            description: 'Deployment Tracking',
            path: '/deployments'
        },
        {
            id: 'groups',
            label: 'User Groups',
            icon: Users,
            description: 'Team & Access Management',
            path: '/groups'
        }
    ],
    styles: {
        active: 'bg-blue-600 text-white shadow-lg shadow-blue-500/20',
        inactive: 'text-gray-400 hover:bg-gray-800 hover:text-white',
        base: 'w-full flex items-center gap-2.5 px-3 py-1.5 md:px-3 md:py-1.5 rounded-lg transition-colors text-xs font-medium'
    }
};
